import { MILL_1 } from "@/setup/mill-config/mill-config";
import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { SectionFamily } from "../models/SectionFamily";

export const getSectionFamilies = async (
	params: {
		sectionFamilyId?: number | null;
		defaultAreaId?: string | number | null;
	},
	signal?: AbortSignal,
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [];

	if (params.sectionFamilyId)
		parameters.push({ name: "SectionFamilyId", value: params.sectionFamilyId });

	const resp = await apiService.callV2(
		Number(params.defaultAreaId) === MILL_1.id
			? "[M1].[GetSectionFamilies]"
			: "[M2].[GetSectionFamilies]",
		parameters,
		signal,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as SectionFamily[];
	} else {
		throw new Error(resp.message || "Error fetching section families");
	}
};
